import axios from 'axios';
import { handleApiError, ResponseSuccessPayload } from 'services/api';
import CookieService from 'services/cookie';
import TokenService from 'services/token';

import { SignInResponse } from './types';

const AuthService = (host: string) =>
  (function (host: string) {
    const signIn = async (username: string, password: string, otp?: string) => {
      try {
        const response = await axios.post<SignInResponse>(
          `https://${host}/api/v5/corporate-api/company-portal/auth/signin`,
          {
            username: username,
            password: password,
            otp: otp
          }
        );

        const payload = response.data.data;
        if (!payload.two_factor_auth) {
          TokenService.updateTokens(
            payload.token,
            payload.refresh_token,
            payload.device_id
          );
          CookieService.setTokenCookie(payload.token, payload.expires_in);
        }
        return payload;
      } catch (e: unknown) {
        throw handleApiError(e);
      }
    };

    const signOut = () => {
      TokenService.removeTokens();
      CookieService.unsetTokenCookie();
      // todo: signOut to revoke refresh token
    };

    const forgotPassword = async (username: string) => {
      try {
        const response = await axios.post<ResponseSuccessPayload>(
          `https://${host}/api/v5/corporate-api/company-portal/auth/forgot-password`,
          {
            email: username
          }
        );
        return response.data;
      } catch (e: unknown) {
        throw handleApiError(e);
      }
    };

    const resetPassword = async (
      username: string,
      password: string,
      token: string
    ) => {
      try {
        const response = await axios.post<ResponseSuccessPayload>(
          `https://${host}/api/v5/corporate-api/company-portal/auth/reset-password`,
          {
            email: username,
            password: password,
            token: token
          }
        );
        return response.data;
      } catch (e: unknown) {
        throw handleApiError(e);
      }
    };

    const setPassword = async (password: string, token: string) => {
      try {
        const response = await axios.post<ResponseSuccessPayload>(
          `https://${host}/api/v5/corporate-api/company-portal/auth/set-password`,
          {
            password: password,
            token: token
          }
        );
        return response.data;
      } catch (e: unknown) {
        throw handleApiError(e);
      }
    };

    return {
      signIn,
      signOut,
      forgotPassword,
      resetPassword,
      setPassword
    };
  })(host);

export default AuthService;
